module.exports = __webpack_public_path__ + "static/media/schedule_type.1df55fcc.png";